import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { Container } from '@pella/sash-framework';
import { contentstackClient } from '../../../utils/contentstack-client';
import { GET_FAQ_BY_TAXONOMY } from '../../../enums/contentstack-graphql';
import { isValidArray } from '../../utilities/validations';
import FAQ from '../faq';
import CTA from '../cta';

const FAQDynamic = ({ data, dynamic, hideStructuredData = false, getFAQData, checkDynamic, multiple, multipleColumns = false, hasContainer = true, className }) => {
	const filters = isValidArray(dynamic?.filter_tags) ? dynamic.filter_tags.map((filter) => ({ taxonomies: { filter_by: { term_in: filter?.split(', ') } } })) : [];
	const { data: faqData } = useQuery(GET_FAQ_BY_TAXONOMY, {
		client: contentstackClient,
		variables: { filters },
		skip: !isValidArray(dynamic?.filter_tags),
		onCompleted: (data) => onLoadCompleted(data?.all_faq?.items),
	});

	const onLoadCompleted = (array) => {
		if (!isValidArray(array) && typeof checkDynamic === 'function') {
			checkDynamic('faq', false);
		}

		if (hideStructuredData && typeof getFAQData === 'function') {
			getFAQData(array);
		}
	};

	if (!isValidArray(dynamic?.filter_tags)) {
		if (typeof checkDynamic === 'function') checkDynamic('faq', false);
		return null;
	}

	return (
		<div className={className || ''}>
			<Container noPadding={!hasContainer}>
				{data?.heading && <h2 className='mb-4'>{data.heading}</h2>}

				<FAQ
					data={faqData?.all_faq?.items}
					noStructuredData={hideStructuredData}
					multipleColumns={multipleColumns}
					multiple={multiple}
				/>

				{isValidArray(dynamic?.ctas) && (
					<div className='mt-4 text-center xl:mt-6'>
						<CTA
							data={dynamic.ctas[0]}
							className='text-sm font-semibold uppercase tracking-wide'
							renderAs='link'
						/>
					</div>
				)}
			</Container>
		</div>
	);
};

FAQDynamic.propTypes = {
	data: PropTypes.object,
	dynamic: PropTypes.object,
	multiple: PropTypes.bool,
	hideStructuredData: PropTypes.bool,
	getFAQData: PropTypes.func,
	checkDynamic: PropTypes.func,
	multipleColumns: PropTypes.bool,
	className: PropTypes.string,
	hasContainer: PropTypes.bool,
};

export default FAQDynamic;
